export default __webpack_public_path__ + "static/media/icon_questionmark.2907cade.png";